// Mock data for the wedding website

export const weddingData = {
  couple: {
    bride: 'Claire',
    groom: 'Thomas',
    weddingDate: '11 juillet 2026',
    weddingTime: '15h00',
    venue: 'Domaine de Launay Guen, Plémet',
    weddingDetails: 'Nous vous attendons le 11 juillet 2026 à 15h00 pour célébrer avec nous cette belle journée.',
    venueDetails: 'Pour passer ce moment magique ensemble, nous avons choisi le magnifique Domaine du Château de Launay Guen, situé à Plémet'
  },
  
  timeline: [
    {
      year: '2007',
      description: 'Après une belle semaine de vacances entre copains, Thomas a appliqué à la lettre ce que le grand Jean-Claude Duss lui a enseigné : "Oublie que tu n\'as aucune chance, fonce!". Claire, elle, a plutôt suivi l\'adage : "Laisse sa chance au produit". Les voilà en couple ! Les Brogneaux (une ingénieuse contraction de Brottes/Costé de Bagneaux) voient le jour, et c\'est le début d\'une loooongue histoire :)'
    },
    {
      year: '2010',
      description: 'Après 3 ans de relation et déjà presque considérés comme un vieux couple, le temps est venu d\'emménager ensemble. Claire & Thomas sont rejoints par une parfaite petite boule de poil : Rocky <3'
    },
    {
      year: '2012',
      description: 'L\'histoire continue, et après un passage express de quelques mois à Castres, une Claire jetlaguée le temps d\'une saison chez Air France, les voilà qui s\'installent à Carrière-sous-Poissy. Fini les études, il est temps de travailler maintenant !'
    },
    {
      year: '2014',
      description: 'Nostalgiques de l\'air breton, ils décident de faire leurs valises pour s\'installer à Rennes. Nouvelle étape, nouvel appartement, nouveaux jobs et de belles nouvelles rencontres !'
    },
    {
      year: '2015',
      description: 'Déjà 8 ans... C\'est le bon moment pour le PACS. Enfin la déclaration d\'impôts commune, quel vrai symbole d\'amour! La famille s\'agrandit et un 4ème membre rejoint l\'aventure : Marty <3'
    },
    {
      year: '2017',
      description: 'Un peu à l\'étroit dans l\'appartement, Claire et Thomas se lancent dans la construction de leur maison. Direction Saint Gondran City pour aller vivre au vert!'
    },
    {
      year: '2019',
      description: 'Le caractère de Claire, l\'humour de Thomas, Mila est née et a pris le meilleur de ses parents. Fini les dimanches chill devant Netflix, les nuits sans interruption et les vêtements sans trace de compote !'
    },
    {
      year: '2024',
      description: 'Après 17 ans d\'amour, et la moitié de leur vie passée ensemble, Thomas choisit ce moment pour faire sa demande, un soir de septembre. La légende raconte que Claire aurait dit oui, sur la plage de Carnac, dans le noir, avant même de voir la bague sous un lampadaire.'
    },
    {
      year: '2026',
      description: '11 Juillet, le jour J que nous préparons depuis tant de mois est enfin là ! On peut, sans trop s\'avancer, vous garantir que cette journée sera mémorable :)'
    }
  ],
  
  location: {
    name: 'Domaine du Château de Launey Guen à Plémet',
    address: '74 Launay Guen, 22210 Plémet',
    coordinates: {
      lat: 48.207438,
      lng: -2.563914
    }
  },
  
  schedule: {
    ceremony: '15h30 : Cérémonie Laïque',
    cocktail: '17h30 : Cocktail',
    dinner: '20h00 : Dîner',
    party: '23h00 : Bal'
  },
  
  contacts: {
    couple: {
      claire: {
        name: 'Claire',
        phone: '06 86 20 19 89'
      },
      thomas: {
        name: 'Thomas',
        phone: '06 12 61 48 33'
      },
      email: 'lesmaries@claire-et-thomas.fr'
    },
    witnesses: {
      female: ['Justine', 'Audrey'],
      male: ['Florian', 'Julien'],
      email: 'lestemoinsquidechirent@claire-et-thomas.fr'
    }
  },
  
  faq: [
    {
      question: 'Avec ou sans enfant ?',
      answer: '✨ Nous adorons vos petits bouts, mais afin de profiter tous ensemble d\'une soirée sereine et festive, nous avons choisi de célébrer notre mariage sans enfants. Merci de votre compréhension et votre présence à nos côtés 💛'
    },
    {
      question: 'Dress code, thème à respecter ?',
      answer: 'Pas de dress code particulier :)\nCependant, la décoration de notre mariage sera colorée, dans les tons vifs et chauds !\nSi le cœur vous en dit, vous pouvez vous inspirer de cette palette de couleur :\nLa cérémonie se déroulera sur une pelouse, donc attention aux talons aiguilles ;)'
    },
    {
      question: 'Où dormir ?',
      answer: 'Pas d\'inquiétude, il y a beaucoup de couchages sur place ! Nous recueillons les besoins de tout le monde avant d\'attribuer les hébergements. Vous pourrez aussi installer votre van ou camping-car dans le domaine, ou bien opter pour un logement à proximité.'
    },
    {
      question: 'Participation aux frais de logement ?',
      answer: 'Afin de couvrir les frais liés au logement, il vous sera demandé une participation à hauteur de 45€ / pers. / nuit. Si vous optez pour une solution extérieure (gîte, hôtel à proximité), nous vous fournirons une petite sélection d\'adresses et vous gérerez la réservation directement avec eux.'
    },
    {
      question: 'Quand faut-il donner une réponse ?',
      answer: 'Pour nous aider à organiser au mieux cette belle journée, nous vous serions reconnaissants de confirmer votre présence avant le 15 janvier.\nNous demanderons également aux personnes qui dormiront sur place d\'effectuer un virement, au plus tard le 31 mars.'
    },
    {
      question: 'Cérémonie déconnectée',
      answer: 'Pour faire de cette cérémonie un moment vrai et pleinement partagé, nous vous invitons à vivre avec nous une cérémonie déconnectée.\nNous préférons voir vos sourires, vos regards et vos émotions… plutôt que vos téléphones.\nPhotographe et vidéaste seront là pour capturer chaque instant : laissez-vous simplement porter, profitez, et soyez présents avec nous.'
    }
  ]
};

// Mock function to simulate form submission
export const mockSubmitForm = async (formData, formType) => {
  console.log(`Submitting ${formType} form:`, formData);
  
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Simulate success response
  return {
    success: true,
    message: formType === 'confirmation' 
      ? 'Votre confirmation a été envoyée avec succès !' 
      : 'Votre message a été envoyé. Nous comprenons votre absence.'
  };
};